/* eslint-disable react/destructuring-assignment */
import React from 'react';
import RenderTooltipCellByTypeView from '../../../shared/components/RenderTooltipCell';

export default function (t) {
  const textEllipsis = {
    maxWidth: '10rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.name}>
          {rowData.name}
        </span>
      ),
    },
    {
      title: t('general.cpf'),
      field: 'formattedCpf',
      cellStyle: textEllipsis,
    },
    { title: t('general.user'), field: 'user' },
    {
      title: t('general.email'),
      field: 'email',
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.email}>
          {rowData.email}
        </span>
      ),
    },
    { title: t('general.active'), field: 'activeDescription' },
    {
      title: t('general.access'),
      field: 'accessProfiles',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.accessProfiles}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
  ];
}
